import React, {useState, useEffect} from 'react';
import classNames from 'classnames';

const StatusEnum = {
    NEW_ACCOUNT: '0',
    SOLD: '1',
    INTERESTED: '2',
    NOT_INTERESTED: '3',
    VOICEMAIL: '4',
    NO_ANSWER: '5',
    SATISFIED: '7',
    REFUND: '8',
    NO_REPLY: '9',
    IN_PROGRESS: '10',
    DO_NOT_VISIT: '11',
    KNOCKED: '12',
    SOLD_2: '28',
    SOLD_3: '29',
    REFUND_2: '30',
    DEAC_REAC: '31',
};

const Status = ({ label, type, expired }) => {
    const getType = () => {
        switch (type) {
            case StatusEnum.NEW_ACCOUNT:
                return 'sl__status__new';
            case StatusEnum.NOT_INTERESTED:
                return 'sl__status__no__sale';
            case StatusEnum.SOLD:
            case StatusEnum.SOLD_2:
            case StatusEnum.SOLD_3:
                return 'sl__status__sold';
            case StatusEnum.VOICEMAIL:
                return 'sl__status__voicemail';
            case StatusEnum.NO_ANSWER:
                return 'sl__status__no__answer';
            case StatusEnum.SATISFIED:
                return 'sl__status__satisfied';
            case StatusEnum.REFUND:
            case StatusEnum.REFUND_2:
                return 'sl__status__refund';
            case StatusEnum.NO_REPLY:
                return 'sl__status__no__reply';
            case StatusEnum.IN_PROGRESS:
                return 'sl__status__in__progress';
            default:
                return 'sl__status__default';
        }
    };

    const [pillType, setType] = useState(getType);
    useEffect(() => {
        setType(getType);
    }, [type]);

    return (
        <div>
            {expired ? <div className={classNames('sl__item__tag', 'sl__status__expired')}>Expired</div> : null}
            <div className={classNames('sl__item__tag', pillType)}>{label}</div>
        </div>
    );
};

Status.defaultProps = {
    label: null,
    type: 'info',
    expired: false,
};

export default Status;



// WEBPACK FOOTER //
// ./src/sections/SmartList/Status.tsx